export default [
    {
        path: 'relatorio-jornada',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-jornada' */
            '@/views/ambulatorio/relatorio-jornada/Index'
        ),
        redirect: 'relatorio-jornada/index',
        children: [
            {
                name: 'ambulatorio-relatorio-jornada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-jornada' */
                    '@/views/ambulatorio/relatorio-jornada/List.vue'
                ),
            },
        ],
    },
]